/** @format */

import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {SaveSpace, Space, SpaceSelections} from 'pages/Home/DigitalCast/models/spaces';

interface Options extends SaveSpace {
  data: Space;
  widgetIds: ChartIds[];
}

const updateSelectedCharts = ({data, widgetIds, saveSpaceSettings}: Options): Space => {
  const newSelections: SpaceSelections = {...data.chartSelected};

  newSelections.previous = [...newSelections.current];
  newSelections.current = widgetIds;

  const result: Space = {
    ...data,
    chartSelected: newSelections,
  };

  saveSpaceSettings(result);

  return result;
};

export default updateSelectedCharts;
